import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import CustomDatePicker from '../common/CustomDatePicker';
import Button from '../common/Button';
import {BiUser, BiCalculator, BiBroadcast, BiMessageAltDetail} from 'react-icons/bi';
import {RiCoupon2Line} from 'react-icons/ri';
import palette from '../../lib/styles/palette';
import TableScrollbar from 'react-table-scrollbar';
import { MdDirectionsRun, MdSettings } from 'react-icons/md';
import {useDeviceStatus} from './DeviceStatusProvider';
import DeviceAlertBadge from './DeviceAlertBadge';

const NavBar = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
`

const NavWrap = styled.ul`
    display: flex;
    align-items: center;
    justify-content: center;

    & li {
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 3px solid #C4C4C4;
        padding: 14px;
        width: 220px;
        color: #C4C4C4;
        cursor: pointer;

        & svg {
            font-size: 1.3rem;
            margin-right: 10px;
        }

        &.active {
            color: ${palette.webCyan[5]};
            font-weight: bold;
            border-bottom: 3px solid ${palette.webCyan[5]};
        }
    }
`;

const RunningTrackNavBar = ({page, setPage}) => {
    const {hasUnread, acknowledge} = useDeviceStatus();

    let history = useHistory();
    
    const movePage = (page) => {
        setPage(page);
    }

    return(
        <NavBar>
            <NavWrap>
                <li onClick={() => {
                    if(page!="ads") movePage("ads")
                }} className={page=="ads" ? "active" : ""}><BiBroadcast />광고</li>
                <li onClick={() => {
                    if(page!="notice") movePage("notice")
                }} className={page=="notice" ? "active" : ""}><BiMessageAltDetail />공지사항</li>
                <li onClick={() => {
                    if(page!="race") movePage("race")
                }} className={page=="race" ? "active" : ""}><MdDirectionsRun />레이스 모드</li>
                <li onClick={() => {
                    acknowledge();
                    if(page!="setting") movePage("setting")
                }} role="button" tabIndex={0} onKeyDown={event => {
                    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); acknowledge(); movePage('setting'); }
                }} className={page=="setting" ? "active" : ""}><MdSettings />설정<DeviceAlertBadge visible={hasUnread}/></li>
                {/* <li onClick={() => {
                    if(page!="clubctransferalculate") movePage("clubctransferalculate")
                }} className={page=="clubctransferalculate" ? "active" : ""}><BiCalculator />클럽 정산</li>
                <li onClick={() => {
                    if(page!="clubmobileauth") movePage("clubmobileauth")
                }} className={page=="clubmobileauth" ? "active" : ""}><BiUser />클럽 정보</li>
                <li onClick={() => {
                    if(page!="clubsms") movePage("clubsms")
                }} className={page=="clubsms" ? "active" : ""}><BiMessageAltDetail />문자</li>
                <li onClick={() => {
                    if(page!="clubsetting") movePage("clubsetting")
                }} className={page=="clubsetting" ? "active" : ""}><RiCoupon2Line />클럽 설정</li> */}
            </NavWrap>
        </NavBar>
    )
};

export default RunningTrackNavBar;
